import React from "react";
import PageHero, { usePageMeta } from "@/components/marketing/PageHero";
import { Users } from "lucide-react";
import { useI18n } from "@/context/I18nContext";

export default function Team() {
  const { lang } = useI18n();
  const L = (it, en, de) => (lang === "en" ? en : lang === "de" ? (de ?? it) : it);
  usePageMeta("Team", L("Il team di specialisti di Recovers Crypto.", "The Recovers Crypto team of specialists.", "Das Spezialistenteam von Recovers Crypto."));
  return (
    <div>
      <PageHero eyebrow="Team" title={L("Specialisti dedicati", "Dedicated specialists", "Engagierte Spezialisten")}
        subtitle={L("Il nostro team combina competenze tecniche di crittografia, wallet e analisi forense digitale.", "Our team combines technical expertise in cryptography, wallets and digital forensics.", "Unser Team vereint technisches Fachwissen in Kryptografie, Wallets und digitaler Forensik.")} />
      <section className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 py-20">
        <div className="rounded-xl border border-dashed border-white/15 bg-navy-paper p-12 text-center" data-testid="team-empty">
          <Users className="mx-auto h-8 w-8 text-slate-600" />
          <p className="mt-3 text-sm text-slate-400">
            {L("I profili del team saranno pubblicati dagli amministratori. I contenuti dimostrativi non vengono mostrati fino all'inserimento di dati reali.", "Team profiles will be published by administrators. Demo content is not shown until real data is entered.", "Team-Profile werden von Administratoren veröffentlicht. Demo-Inhalte werden erst angezeigt, wenn echte Daten eingegeben wurden.")}
          </p>
        </div>
      </section>
    </div>
  );
}
